export default __webpack_public_path__ + "static/media/expand_less.3eb42d42.svg";